/**
 * Chips de atajos de fecha (Hoy / 7 días / 30 días / Mes) — tipo el selector del
 * admin, adaptado a mobile premium. Se monta encima de los inputs <input type=date>
 * existentes: al tocar un chip, setea desde/hasta y dispara su evento change (así
 * la vista recarga con su lógica actual, sin tocarla).
 *
 * Reutilizable por las vistas con rango de fechas (réditos, afiliados, embudo,
 * campañas). NO reemplaza los inputs — los complementa (el "personalizado" sigue
 * siendo tocar los inputs).
 */
import { t } from '../languages.js';

function iso(d) {
    return d.toISOString().split('T')[0];
}

// Definición de los atajos: cada uno calcula su rango desde "hoy".
const ATAJOS = [
    { id: 'hoy', key: 'fechas.hoy', dias: 0 },
    { id: '7d', key: 'fechas.semana', dias: 7 },
    { id: '30d', key: 'fechas.mes', dias: 30 },
];

/**
 * Crea la barra de chips. Recibe los inputs desde/hasta a controlar.
 * @param {{ desdeEl: HTMLInputElement, hastaEl: HTMLInputElement, onChange: ()=>void }} ctx
 * @returns {HTMLElement}
 */
export function renderChipsFecha({ desdeEl, hastaEl, onChange }) {
    const cont = document.createElement('div');
    cont.className = 'pm-chips-fecha';
    cont.innerHTML = ATAJOS.map(
        (a) => `<button type="button" class="pm-chip" data-atajo="${a.id}">${t(a.key)}</button>`
    ).join('');

    function aplicar(atajo) {
        const hoy = new Date();
        const desde = new Date(hoy.getTime() - atajo.dias * 86400000);
        desdeEl.value = iso(desde);
        hastaEl.value = iso(hoy);
        // Marcar el chip activo.
        cont.querySelectorAll('.pm-chip').forEach((c) => c.classList.toggle('active', c.dataset.atajo === atajo.id));
        if (onChange) onChange();
    }

    cont.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-atajo]');
        if (!btn) return;
        const atajo = ATAJOS.find((a) => a.id === btn.dataset.atajo);
        if (atajo) aplicar(atajo);
    });

    // Si el usuario toca los inputs (personalizado), desmarcar los chips.
    const desmarcar = () => cont.querySelectorAll('.pm-chip').forEach((c) => c.classList.remove('active'));
    desdeEl.addEventListener('change', desmarcar);
    hastaEl.addEventListener('change', desmarcar);

    // Marcar "30d" activo por defecto (coincide con rangoPorDefecto).
    cont.querySelector('[data-atajo="30d"]').classList.add('active');

    return cont;
}
